export const IMPORT_FILE_REQUIREMENTS = [
  'Обязательные поля: Email, ФИО (Фамилия, Имя, Отчество)',
  'Опциональное поле: ID трека',
  'Email должен быть уникальным для каждого сотрудника',
  'Первая строка файла должна содержать заголовки столбцов',
  'Рекомендуется использовать предоставленный шаблон',
];

export const TRACK_ID_TIP_TEXT = `Чтобы найти ID трека:
1. Перейдите в управление контентом программы обучения (путем нажатия на бейдж программы обучения в своем профиле)
2. Выберите раздел "Треки развития" в вертикальном меню слева
3. Найдите трек развития, в который должны добавляться участники программы обучения
4. Нажмите на трек развития левой клавишей мыши
5. Обратите внимание на адресную строку в которой отображается URL. Она будет иметь следующий вид - "https//...career_tracks/track/id/...", где id = ID трека`;

export const MIN_VALIDATION_MODAL_DISPLAY_MS = 1000;
